import React, { useEffect, useState } from "react";
import { Container, Row } from "./style";
import { Tab } from "semantic-ui-react";
import ArtisteProfile from "./ArtisteProfile";
import UpdateProfile from "./UpdateProfile";
import UploadMusic from "./UploadMusic";

const panes = [
  {
    menuItem: "Artiste Profile",
    render: () => (
      <Tab.Pane>
        <ArtisteProfile />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Upload",
    render: () => (
      <Tab.Pane>
        <UploadMusic />
      </Tab.Pane>
    ),
  },
  {
    menuItem: "Update Profile",
    render: () => (
      <Tab.Pane>
        <UpdateProfile />
      </Tab.Pane>
    ),
  },
];

const ArtisteDashboard = () => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    window.addEventListener("resize", function () {
      setWidth(this.window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", function () {
        setWidth(this.window.innerWidth);
      });
    };
  }, []);
  console.log(width);
  return (
    <Container>
      <Row>
        <Tab
          menu={{
            fluid: true,
            vertical: width < 800 ? false : true,
            tabular: true,
          }}
          panes={panes}
        />
      </Row>
    </Container>
  );
};

export default ArtisteDashboard;
